import { render, staticRenderFns } from "./ReadingTheData.vue?vue&type=template&id=41865737&"
import script from "./ReadingTheData.vue?vue&type=script&lang=js&"
export * from "./ReadingTheData.vue?vue&type=script&lang=js&"
import style0 from "./ReadingTheData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports